import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useSelector, shallowEqual } from "react-redux";
import { GetHistory } from "./api";
import moment from "moment";
import { CSVLink } from "react-csv";

function Subscription() {
  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  const [pending, setPending] = useState(false);

  const [cpackage, setCpackage] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    (async function() {
      try {
        setPending(true);
        let res = await GetHistory(user.id);
        setCpackage(res.data.package);
        setHistory(
          res.data.history.map((item) => {
            return {
              ...item,
              amount: `$${item.amount / 100}`,
              createdAt: moment(item.createdAt).format("MM/DD/yyyy"),
              expiredAt: moment(item.createdAt)
                .add(1, "month")
                .format("MM/DD/yyyy"),
              status: res.data.package.payment == item._id ? "Active" : null,
            };
          })
        );
      } catch (ex) {
        console.log(ex);
      } finally {
        setPending(false);
      }
    })();
  }, []);

  const CSVHeaders = [
    { label: "Name", key: "metadata.name" },
    { label: "Amount", key: "amount" },
    { label: "Start", key: "createdAt" },
    { label: "End", key: "expiredAt" },
    { label: "Status", key: "status" },
  ];

  return (
    <div>
      {
        // <div className='col-lg-3 col-sm-6 text-dark rounded-sm bg-white py-5 shadow-sm'>
        //     <Row>
        //         <label hmtlFor="one" className="form-label pl-2 font-weight-bold">Time LEFT</label>
        //         <div className='ml-5' id="one">
        //             <h5 style={{ fontSize: "14px" }}>D : H : M : S</h5>
        //             <h5 style={{ fontSize: "14px" }}>5 : 2 : 10 : 50</h5>
        //         </div>
        //     </Row>
        //     <h1 className='text-center mt-5 font-bold text-dark'>US$<span className='display-1 font-weight-bold'>00</span></h1>
        //     <button
        //         className="rounded-sm px-5 py-2 border-0   text-white text-light"
        //         style={{ backgroundColor: "#FF4242", width: "70%", marginLeft: "15%" }}>FREE TRAIL</button>
        // </div>
      }
      <h1 className="mb-5">Subscription</h1>
      <div className=" rounded-lg overflow-hidden border mt-10">
        <div className="d-flex align-items-center ">
          <form
            className="navbar-form navbar-left d-flex  w-100 justify-content-between align-items-center px-3 py-5"
            style={{
              background: "#ebf2f3",
              borderBottom: "3px solid #FFF",
            }}
          >
            <h1 className="pt-2 pl-2">History</h1>
            <div className=" d-flex align-items-center">
              {/* <button
                                className=" px-5 py-2 rounded-sm border-0 btn_color text-white ml-3"
                            >
                                Export CSV
                            </button> */}
              <CSVLink
                data={history}
                target="_blank"
                className="px-5 py-4 rounded-sm border-0 btn_color text-white ml-3"
                headers={CSVHeaders}
                filename={`report_${new Date().getTime()}.csv`}
                onClick={() => {
                  if (pending) {
                    alert("fetching data");
                    return false;
                  }
                }}
              >
                CSV Export
              </CSVLink>
            </div>
          </form>
        </div>
        <table className="table m-0">
          <thead className="bg-light">
            <tr>
              <th style={{ fontSize: "16px" }}>Pakage</th>
              <th style={{ fontSize: "16px" }}>Amount</th>
              <th style={{ fontSize: "16px" }}>Start Date</th>
              <th style={{ fontSize: "16px" }}>End Date</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {pending ? (
              <tr>
                <td colSpan={4}>
                  <div className="w-100 d-flex align-items-center justify-content-between mb-2">
                    <div
                      class="spinner-border text-danger mx-auto"
                      role="status"
                    ></div>
                  </div>
                </td>
              </tr>
            ) : (
              history.map((item, i) => {
                return (
                  <tr key={i} className="">
                    <td className="align-middle py-2">
                      {item.metadata && item.metadata.name}{" "}
                      {cpackage && cpackage.payment == item._id && (
                        <span
                          style={{ fontSize: "10px", color: "#04AA6D" }}
                        >
                          Active
                        </span>
                      )}
                    </td>
                    <td className='align-middle'>{item.amount}</td>
                    <td className="td1 align-middle">{item.createdAt}</td>
                    <td className='align-middle'>{item.expiredAt}</td>
                  </tr>
                );
              })
            )}
            {!pending && history.length == 0 && (
              <tr>
                <td align="center" colSpan={4}>
                  No History Available
                </td>
              </tr>
            )}
            {
              // {pending ? (
              //   <tr>
              //     <td colSpan={5}>
              //       <div className="w-100 d-flex align-items-center justify-content-between mb-2">
              //         <div
              //           className="spinner-border text-danger mx-auto"
              //           role="status"
              //         ></div>
              //       </div>
              //     </td>
              //   </tr>
              // ) : (
              //   payments.map((item, index) => {
              //     return (
              //       <tr key={index} className="">
              //         <td></td>
              //         <td>{item.userId.firstName} {item.userId.lastName}</td>
              //         <td className="td1">25/03/2023</td>
              //         <td>27/03/2023</td>
              //       </tr>
              //     );
              //   })
              // )}
              // {!pending && payments.length == 0 && <tr><td align='center' colSpan={5}>No Sale Available</td></tr>}
            }
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Subscription;
